"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmailAddress = validateEmailAddress;
const constants_1 = require("@daytrip/constants");
function validateEmailAddress(email, allowEmptyStringNullUndefined = false) {
    if (email === undefined || email === null || email === "") {
        return allowEmptyStringNullUndefined ? undefined : "EMPTY_EMAIL_ADDRESS";
    }
    if (typeof email !== "string") {
        return "EMAIL_SHOULD_BE_STRING";
    }
    if (!constants_1.EMAIL_REGEX.test(email)) {
        return "INVALID_EMAIL_FORMAT";
    }
    return undefined;
}
//# sourceMappingURL=validateEmailAddress.js.map